import { NgModule } from '@angular/core';
import { AccountProductsDataModule } from '@epicuro-next/data/account-products-data';
import { ConfigurationModule } from '@epicuro-next/platform/configuration';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { CustomerProductIdentifiersEffects } from './customer-product-identifiers/customer-product-identifiers.effects';
import {
  customerProductIdentifiersFeatureKey,
  reducer,
} from './customer-product-identifiers/customer-product-identifiers.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature(customerProductIdentifiersFeatureKey, reducer),
    EffectsModule.forFeature([CustomerProductIdentifiersEffects]),
    AccountProductsDataModule,
    ConfigurationModule,
  ],
})
export class CustomerProductIdentifiersStateModule {}
